import React, { useEffect, useState } from "react";
import { Spin, Tag, Timeline, Typography } from "antd";
import { get_agent_conversation_by_id } from "../../../../../api/endpoints/agents";
import { CONSTANTS } from "../../../../../utils/constants";
import moment from "moment";

const { Text, Paragraph } = Typography;

export default function ConversationPanel({ open, conversationId }) {
	const [loading, setLoading] = useState(false);
	const [conversation, setConversation] = useState(null);

	useEffect(() => {
		const fetchConversation = async () => {
			if (!open || !conversationId) return;
			setLoading(true);
			try {
				const res = await get_agent_conversation_by_id(conversationId);
				setConversation(res);
			} catch (e) {
				console.error(e);
			} finally {
				setLoading(false);
			}
		};

		fetchConversation();
	}, [open, conversationId]);

	if (loading) return <Spin />;
	if (!conversation)
		return <Text type="secondary">No se encontró la conversación.</Text>;

	return (
		<Timeline>
			{conversation.messages?.map((m) => (
				<Timeline.Item
					key={m.id}
					color={CONSTANTS.AGENT_CONVERSATION[m.role]?.color}
				>
					<Tag color={CONSTANTS.AGENT_CONVERSATION[m.role]?.color || "blue"}>
						{CONSTANTS.AGENT_CONVERSATION[m.role]?.label || ""}
					</Tag>
					<Paragraph style={{ whiteSpace: "pre-wrap" }}>{m.content}</Paragraph>
					<Text type="secondary" style={{ fontSize: 11 }}>
						{moment(m.created).format("DD-MM-YYYY HH:mm:ss")}
					</Text>
				</Timeline.Item>
			))}
		</Timeline>
	);
}
